import {PENDING, FULFILLED} from '../actions/constants';
import update from 'immutability-helper';
import * as EntryActions from "../actions/EntryActions";


export default (state = {
    items: {},
    filteredItems: {}, // used for reporting
    fetching: false,
    fetched: false,
    isFetching: {},
    isFetched: {},
    active: null,
    createFetching: false,
    minutes: {all:{}},
}, action) => {
    switch (action.type){
        case EntryActions.FETCH_ENTRIES + PENDING:
            return update(state, {
                fetching: {$set: true},
                isFetching: {[action.meta.key]: {$set: true}},
            });
        case EntryActions.FETCH_ENTRIES + FULFILLED:
            return update(state, {
                items: {$merge: action.payload},
                isFetched: {[action.meta.key]: {$set: true}},
                isFetching: {[action.meta.key]: {$set: false}},
                fetching: {$set: false},
                fetched: {$set: true},
                minutes: {$merge: createMinutesTable(action.payload, state.minutes)}
            });

        case EntryActions.FETCH_FILTERED_ENTRIES + PENDING:
            return update(state, {
                fetching: {$set: true},
                isFetching: {[action.meta.key]: {$set: true}},
            });
        case EntryActions.FETCH_FILTERED_ENTRIES + FULFILLED:
            return update(state, {
                filteredItems: {
                    [action.meta.key] : {$set: action.payload}
                },
                isFetched: {[action.meta.key]: {$set: true}},
                isFetching: {[action.meta.key]: {$set: false}},
                fetching: {$set: false},
                fetched: {$set: true},
            });


        case EntryActions.SAVE_ENTRY + PENDING:
            return update(state, {
                createFetching: {$set: true},
            });

        case EntryActions.SAVE_ENTRY + FULFILLED:
            let mergeObject = action.payload.id ? {[action.payload.id]: action.payload} : action.payload;
            let entry = action.payload.id ? action.payload : Object.values(action.payload)[0];
            return update(state, {
                // fetched: {$set: false},
                // isFetched: {$set: {}},
                createFetching: {$set: false},
                items: {$merge: mergeObject},
                minutes: {$merge: createMinutesTable(mergeObject, state.minutes, (action.meta && action.meta.user), entry.minutes - action.meta.previousMinutes)}
            });

        case EntryActions.REMOVE_ENTRY + PENDING:
            return update(state, {
                createFetching: {$set: true},
            });
        case EntryActions.REMOVE_ENTRY + FULFILLED:
            return update(state, {
                fetched: {$set: false},
                isFetched: {$set: {}},
                createFetching: {$set: false},
                items: {$unset: [action.meta.entryId]},
            });

        default:
            return state;
    }
};

const createMinutesTable = (entries, initialValue, user, minutesDiff) => {
    let all = initialValue || {all: {}};
    for (let entry of Object.values(entries)) {
        let userId = entry.user ? entry.user.id : (user && user.id);
        let date = parseInt(entry.date, 10);
        let minutes = minutesDiff ? minutesDiff : entry.minutes;
        if (all[userId] === undefined) {
            all[userId] = {};
        }
        if (all[userId][date] === undefined) {
            all[userId][date] = 0;
        }
        if (all["all"][date] === undefined) {
            all["all"][date] = 0;
        }
        all[userId][date] += minutes;
        all["all"][date] += minutes;
    }
    return all;
};




// WEBPACK FOOTER //
// ./src/reducers/EntriesReducer.js